import React, { useEffect, useState, useContext } from "react";








import useSettings from "../../hooks/useSettings";

import { makeStyles } from "@material-ui/core/styles";
import { grey, blue } from "@material-ui/core/colors";

import { Tab, Tabs } from "@material-ui/core";
import { 
  Card, CardContent, Typography, Box, Divider, useTheme, 
  Switch, Paper, TextField, Select, MenuItem, FormControl, InputLabel, FormHelperText, Grid 
} from "@mui/material";
import { i18n } from "../../translate/i18n";
import useCompanySettings from "../../hooks/useSettings/companySettings";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 240,
  },
  cardAvatar: {
    fontSize: "55px",
    color: theme.palette.text.secondary,
    backgroundColor: "#ffffff",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: theme.palette.primary.main,
  },
  cardSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  tab: {
    backgroundColor: theme.palette.background.default,
    width: "100%",
    "& .MuiTabs-flexContainer": {
      justifyContent: "center"
    }
  },
}));

export default function Options(props) {
  const { oldSettings, settings, scheduleTypeChanged, user } = props;

  const classes = useStyles();
  const [userRating, setUserRating] = useState("disabled");
  const [scheduleType, setScheduleType] = useState("disabled");
  const [chatBotType, setChatBotType] = useState("text");

  const [loadingUserRating, setLoadingUserRating] = useState(false);
  const [loadingScheduleType, setLoadingScheduleType] = useState(false);

  const [userCreation, setUserCreation] = useState("disabled");
  const [loadingUserCreation, setLoadingUserCreation] = useState(false);

  const [SendGreetingAccepted, setSendGreetingAccepted] = useState("enabled");
  const [loadingSendGreetingAccepted, setLoadingSendGreetingAccepted] = useState(false);

  const [UserRandom, setUserRandom] = useState("enabled");
  const [loadingUserRandom, setLoadingUserRandom] = useState(false);

  const [SettingsTransfTicket, setSettingsTransfTicket] = useState("enabled");
  const [loadingSettingsTransfTicket, setLoadingSettingsTransfTicket] = useState(false);

  const [AcceptCallWhatsapp, setAcceptCallWhatsapp] = useState("enabled");
  const [loadingAcceptCallWhatsapp, setLoadingAcceptCallWhatsapp] = useState(false);

  const [sendSignMessage, setSendSignMessage] = useState("enabled");
  const [loadingSendSignMessage, setLoadingSendSignMessage] = useState(false);

  const [sendGreetingMessageOneQueues, setSendGreetingMessageOneQueues] = useState("enabled");
  const [loadingSendGreetingMessageOneQueues, setLoadingSendGreetingMessageOneQueues] = useState(false);

  const [sendQueuePosition, setSendQueuePosition] = useState("enabled");
  const [loadingSendQueuePosition, setLoadingSendQueuePosition] = useState(false);

  const [sendFarewellWaitingTicket, setSendFarewellWaitingTicket] = useState("enabled");
  const [loadingSendFarewellWaitingTicket, setLoadingSendFarewellWaitingTicket] = useState(false);

  const [acceptAudioMessageContact, setAcceptAudioMessageContact] = useState("enabled");
  const [loadingAcceptAudioMessageContact, setLoadingAcceptAudioMessageContact] = useState(false);

  //LGPD
  const [enableLGPD, setEnableLGPD] = useState("disabled");
  const [loadingEnableLGPD, setLoadingEnableLGPD] = useState(false);

  const [lgpdMessage, setLGPDMessage] = useState("");
  const [loadinglgpdMessage, setLoadingLGPDMessage] = useState(false);

  const [lgpdLink, setLGPDLink] = useState("");
  const [loadingLGPDLink, setLoadingLGPDLink] = useState(false);

  const [lgpdDeleteMessage, setLGPDDeleteMessage] = useState("disabled");
  const [loadingLGPDDeleteMessage, setLoadingLGPDDeleteMessage] = useState(false);

  const [lgpdConsent, setLGPDConsent] = useState("disabled");
  const [loadingLGPDConsent, setLoadingLGPDConsent] = useState(false);

  const [lgpdHideNumber, setLGPDHideNumber] = useState("disabled");
  const [loadingLGPDHideNumber, setLoadingLGPDHideNumber] = useState(false);

  // Tag obrigatoria
  const [requiredTag, setRequiredTag] = useState("enabled")
  const [loadingRequiredTag, setLoadingRequiredTag] = useState(false)

  // Fechar ticket ao transferir para outro setor
  const [closeTicketOnTransfer, setCloseTicketOnTransfer] = useState(false)
  const [loadingCloseTicketOnTransfer, setLoadingCloseTicketOnTransfer] = useState(false)

  // Usar carteira de clientes
  const [directTicketsToWallets, setDirectTicketsToWallets] = useState(false)
  const [loadingDirectTicketsToWallets, setLoadingDirectTicketsToWallets] = useState(false)

  //MENSAGENS CUSTOMIZADAS
  const [transferMessage, setTransferMessage] = useState("Seu Atendimento foi Transferido para o setor ${queue.name},Aguarde atendimento por favor...");
  const [loadingTransferMessage, setLoadingTransferMessage] = useState(false);

  const [greetingAcceptedMessage, setGreetingAcceptedMessage] = useState("");
  const [loadingGreetingAcceptedMessage, setLoadingGreetingAcceptedMessage] = useState(false);
  
  const [AcceptCallWhatsappMessage, setAcceptCallWhatsappMessage] = useState("");
  const [loadingAcceptCallWhatsappMessage, setLoadingAcceptCallWhatsappMessage] = useState(false);

  const [sendQueuePositionMessage, setSendQueuePositionMessage] = useState("");
  const [loadingSendQueuePositionMessage, setLoadingSendQueuePositionMessage] = useState(false);

  const [outOfHoursMessage, setOutOfHoursMessage] = useState("");
  const [loadingOutOfHoursMessage, setLoadingOutOfHoursMessage] = useState(false);

  const [showNotificationPending, setShowNotificationPending] = useState(false);
  const [loadingShowNotificationPending, setLoadingShowNotificationPending] = useState(false);

  const { update: updateUserCreation, getAll } = useSettings();

  const { update } = useCompanySettings();

  const isSuper = () => {
    return user.super;
  };


  useEffect(() => {

    if (Array.isArray(oldSettings) && oldSettings.length) {

      const userPar = oldSettings.find((s) => s.key === "userCreation");

      if (userPar) {
        setUserCreation(userPar.value);
      }
    }
  }, [oldSettings])


  useEffect(() => {
    for (const [key, value] of Object.entries(settings)) {
      if (key === "userRating") setUserRating(value);
      if (key === "scheduleType") setScheduleType(value);
      if (key === "chatBotType") setChatBotType(value);
      if (key === "acceptCallWhatsapp") setAcceptCallWhatsapp(value);
      if (key === "userRandom") setUserRandom(value);
      if (key === "sendGreetingMessageOneQueues") setSendGreetingMessageOneQueues(value);
      if (key === "sendSignMessage") setSendSignMessage(value);
      if (key === "sendFarewellWaitingTicket") setSendFarewellWaitingTicket(value);
      if (key === "sendGreetingAccepted") setSendGreetingAccepted(value);
      if (key === "sendQueuePosition") setSendQueuePosition(value);
      if (key === "acceptAudioMessageContact") setAcceptAudioMessageContact(value);
      if (key === "enableLGPD") setEnableLGPD(value);
      if (key === "requiredTag") setRequiredTag(value);
      if (key === "lgpdDeleteMessage") setLGPDDeleteMessage(value)
      if (key === "lgpdHideNumber") setLGPDHideNumber(value);
      if (key === "lgpdConsent") setLGPDConsent(value);
      if (key === "lgpdMessage") setLGPDMessage(value);
      if (key === "sendMsgTransfTicket") setSettingsTransfTicket(value);
      if (key === "lgpdLink") setLGPDLink(value);
      if (key === "DirectTicketsToWallets") setDirectTicketsToWallets(value);
      if (key === "closeTicketOnTransfer") setCloseTicketOnTransfer(value);
      if (key === "transferMessage") setTransferMessage(value);
      if (key === "greetingAcceptedMessage") setGreetingAcceptedMessage(value);
      if (key === "AcceptCallWhatsappMessage") setAcceptCallWhatsappMessage(value);
      if (key === "sendQueuePositionMessage") setSendQueuePositionMessage(value);
      if (key === "outOfHoursMessage") setOutOfHoursMessage(value);
      if (key === "showNotificationPending") setShowNotificationPending(value);

    }
  }, [settings]);

  async function handleChangeUserCreation(value) {
    setUserCreation(value);
    setLoadingUserCreation(true);
    await updateUserCreation({
      key: "userCreation",
      value,
    });
    setLoadingUserCreation(false);
  }

  async function handleChangeUserRating(value) {
    setUserRating(value);
    setLoadingUserRating(true);
    await update({
      column: "userRating",
      data: value
    });
    setLoadingUserRating(false);
  }

  async function handleScheduleType(value) {
    setScheduleType(value);
    setLoadingScheduleType(true);
    await update({
      column: "scheduleType",
      data: value
    });
    setLoadingScheduleType(false);
    if (typeof scheduleTypeChanged === "function") {
      scheduleTypeChanged(value);
    }
  }

  async function handleChatBotType(value) {
    setChatBotType(value);
    await update({
      column: "chatBotType",
      data: value
    });
    if (typeof scheduleTypeChanged === "function") {
      setChatBotType(value);
    }
  }

  async function handleLGPDMessage(value) {
    setLGPDMessage(value);
    setLoadingLGPDMessage(true);
    await update({
      column: "lgpdMessage",
      data: value
    });
    setLoadingLGPDMessage(false);
  }

  async function handletransferMessage(value) {
    setTransferMessage(value);
    setLoadingTransferMessage(true);
    await update({
      column: "transferMessage",
      data: value
    });
    setLoadingTransferMessage(false);
  }

  async function handleGreetingAcceptedMessage(value) {
    setGreetingAcceptedMessage(value);
    setLoadingGreetingAcceptedMessage(true);
    await update({
      column: "greetingAcceptedMessage",
      data: value
    });
    setLoadingGreetingAcceptedMessage(false);
  }

  async function handleAcceptCallWhatsappMessage(value) {
    setAcceptCallWhatsappMessage(value);
    setLoadingAcceptCallWhatsappMessage(true);
    await update({
      column: "AcceptCallWhatsappMessage",
      data: value
    });
    setLoadingAcceptCallWhatsappMessage(false);
  }

  async function handlesendQueuePositionMessage(value) {
    setSendQueuePositionMessage(value);
    setLoadingSendQueuePositionMessage(true);
    await update({
      column: "sendQueuePositionMessage",
      data: value
    });
    setLoadingSendQueuePositionMessage(false);
  }

  async function handleOutOfHoursMessage(value) {
    setOutOfHoursMessage(value);
    setLoadingOutOfHoursMessage(true);
    await update({
      column: "outOfHoursMessage",
      data: value
    });
    setLoadingOutOfHoursMessage(false);
  }

  async function handleShowNotificationPending(value) {
    setShowNotificationPending(value);
    setLoadingShowNotificationPending(true);
    await update({
      column: "showNotificationPending",
      data: value
    });
    setLoadingShowNotificationPending(false);
  }

  async function handleLGPDLink(value) {
    setLGPDLink(value);
    setLoadingLGPDLink(true);
    await update({
      column: "lgpdLink",
      data: value
    });
    setLoadingLGPDLink(false);
  }

  async function handleLGPDDeleteMessage(value) {
    setLGPDDeleteMessage(value);
    setLoadingLGPDDeleteMessage(true);
    await update({
      column: "lgpdDeleteMessage",
      data: value
    });
    setLoadingLGPDDeleteMessage(false);
  }

  async function handleLGPDConsent(value) {
    setLGPDConsent(value);
    setLoadingLGPDConsent(true);
    await update({
      column: "lgpdConsent",
      data: value
    });
    setLoadingLGPDConsent(false);
  }

  async function handleLGPDHideNumber(value) {
    setLGPDHideNumber(value);
    setLoadingLGPDHideNumber(true);
    await update({
      column: "lgpdHideNumber",
      data: value
    });
    setLoadingLGPDHideNumber(false);
  }

  async function handleSendGreetingAccepted(value) {
    setSendGreetingAccepted(value);
    setLoadingSendGreetingAccepted(true);
    await update({
      column: "sendGreetingAccepted",
      data: value
    });
    setLoadingSendGreetingAccepted(false);
  }

  async function handleUserRandom(value) {
    setUserRandom(value);
    setLoadingUserRandom(true);
    await update({
      column: "userRandom",
      data: value
    });
    setLoadingUserRandom(false);
  }

  async function handleSettingsTransfTicket(value) {
    setSettingsTransfTicket(value);
    setLoadingSettingsTransfTicket(true);
    await update({
      column: "sendMsgTransfTicket",
      data: value
    });
    setLoadingSettingsTransfTicket(false);
  }

  async function handleAcceptCallWhatsapp(value) {
    setAcceptCallWhatsapp(value);
    setLoadingAcceptCallWhatsapp(true);
    await update({
      column: "acceptCallWhatsapp",
      data: value
    });
    setLoadingAcceptCallWhatsapp(false);
  }

  async function handleSendSignMessage(value) {
    setSendSignMessage(value);
    setLoadingSendSignMessage(true);
    await update({
      column: "sendSignMessage",
      data: value
    });
    localStorage.setItem("sendSignMessage", value === "enabled" ? true : false); //atualiza localstorage para sessão
    setLoadingSendSignMessage(false);
  }

  async function handleSendGreetingMessageOneQueues(value) {
    setSendGreetingMessageOneQueues(value);
    setLoadingSendGreetingMessageOneQueues(true);
    await update({
      column: "sendGreetingMessageOneQueues",
      data: value
    });
    setLoadingSendGreetingMessageOneQueues(false);
  }

  async function handleSendQueuePosition(value) {
    setSendQueuePosition(value);
    setLoadingSendQueuePosition(true);
    await update({
      column: "sendQueuePosition",
      data: value
    });
    setLoadingSendQueuePosition(false);
  }

  async function handleSendFarewellWaitingTicket(value) {
    setSendFarewellWaitingTicket(value);
    setLoadingSendFarewellWaitingTicket(true);
    await update({
      column: "sendFarewellWaitingTicket",
      data: value
    });
    setLoadingSendFarewellWaitingTicket(false);
  }

  async function handleAcceptAudioMessageContact(value) {
    setAcceptAudioMessageContact(value);
    setLoadingAcceptAudioMessageContact(true);
    await update({
      column: "acceptAudioMessageContact",
      data: value
    });
    setLoadingAcceptAudioMessageContact(false);
  }

  async function handleEnableLGPD(value) {
    setEnableLGPD(value);
    setLoadingEnableLGPD(true);
    await update({
      column: "enableLGPD",
      data: value
    });
    setLoadingEnableLGPD(false);
  }

  async function handleRequiredTag(value) {
    setRequiredTag(value);
    setLoadingRequiredTag(true);
    await update({
      column: "requiredTag",
      data: value,
    });
    setLoadingRequiredTag(false);
  }

  async function handleCloseTicketOnTransfer(value) {
    setCloseTicketOnTransfer(value);
    setLoadingCloseTicketOnTransfer(true);
    await update({
      column: "closeTicketOnTransfer",
      data: value,
    });
    setLoadingCloseTicketOnTransfer(false);
  }

  async function handleDirectTicketsToWallets(value) {
    setDirectTicketsToWallets(value);
    setLoadingDirectTicketsToWallets(true);
    await update({
      column: "DirectTicketsToWallets",
      data: value,
    });
    setLoadingDirectTicketsToWallets(false);
  }

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        
        {/* ======================= GERAIS ======================= */}
        <Card elevation={0} sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
          <CardContent>
            <Typography variant="h6" color="primary" gutterBottom fontWeight="bold">
              Configurações Gerais e Expediente
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
              Gerenciamento global e comportamentos essenciais do sistema.
            </Typography>
            <Grid spacing={3} container>

              {isSuper() && (
                <Grid item xs={12} sm={6} md={4}>
                  <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight="bold">{i18n.t("settings.settings.options.creationCompanyUser")}</Typography>
                      <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Habilitar controle e criação de companhias/usuários no escopo de multi-empresa.</Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Typography variant="caption" color={loadingUserCreation ? 'primary' : 'textSecondary'}>{loadingUserCreation ? i18n.t("settings.settings.options.updating") : (userCreation==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                      <Switch color="primary" checked={userCreation === "enabled"} onChange={async (e) => handleChangeUserCreation(e.target.checked ? "enabled" : "disabled")} />
                    </Box>
                  </Paper>
                </Grid>
              )}

              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">{i18n.t("settings.settings.options.evaluations")}</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Envio de pesquisa de satisfação (NPS) ao finalizar, avaliando a qualidade do atendimento.</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" color={loadingUserRating ? 'primary' : 'textSecondary'}>{loadingUserRating ? i18n.t("settings.settings.options.updating") : (userRating==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                    <Switch color="primary" checked={userRating === "enabled"} onChange={async (e) => handleChangeUserRating(e.target.checked ? "enabled" : "disabled")} />
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">{i18n.t("settings.settings.options.officeScheduling")}</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Filtro e controle do fluxo de horário de expediente em andamento.</Typography>
                  </Box>
                  <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                    <Select value={scheduleType} onChange={async (e) => handleScheduleType(e.target.value)}>
                      <MenuItem value={"disabled"}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
                      <MenuItem value={"queue"}>{i18n.t("settings.settings.options.queueManagement")}</MenuItem>
                      <MenuItem value={"company"}>{i18n.t("settings.settings.options.companyManagement")}</MenuItem>
                      <MenuItem value={"connection"}>{i18n.t("settings.settings.options.connectionManagement")}</MenuItem>
                    </Select>
                  </FormControl>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">Mostar Notificações Pendentes</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Exibe as notificações e alertas visuais de chamados e tickets pendentes.</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" color={loadingShowNotificationPending ? 'primary' : 'textSecondary'}>{loadingShowNotificationPending ? i18n.t("settings.settings.options.updating") : (showNotificationPending===true || showNotificationPending==="true" ? "Habilitado" : "Desabilitado")}</Typography>
                    <Switch color="primary" checked={showNotificationPending === true || showNotificationPending === "true"} onChange={async (e) => handleShowNotificationPending(e.target.checked)} />
                  </Box>
                </Paper>
              </Grid>

            </Grid>
          </CardContent>
        </Card>

        {/* ======================= AUTOMAÇAO ======================= */}
        <Card elevation={0} sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
          <CardContent>
            <Typography variant="h6" color="primary" gutterBottom fontWeight="bold">
              Automação de Atendimento e Filas
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
              Regras automáticas para envio de mensagens, bloqueios de áudio e ligações, distribuições na fila e encerramento de ticket.
            </Typography>
            <Grid spacing={3} container>

              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">{i18n.t("settings.settings.options.sendGreetingAccepted")}</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Enviar saudação pré-definida no momento em que o atendente aceita o ticket.</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" color={loadingSendGreetingAccepted ? 'primary' : 'textSecondary'}>{loadingSendGreetingAccepted ? i18n.t("settings.settings.options.updating") : (SendGreetingAccepted==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                    <Switch color="primary" checked={SendGreetingAccepted === "enabled"} onChange={async (e) => handleSendGreetingAccepted(e.target.checked ? "enabled" : "disabled")} />
                  </Box>
                </Paper>
              </Grid>

               <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">{i18n.t("settings.settings.options.userRandom")}</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Distribuição automática e aleatória de tickets novos entre os atendentes livres.</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" color={loadingUserRandom ? 'primary' : 'textSecondary'}>{loadingUserRandom ? i18n.t("settings.settings.options.updating") : (UserRandom==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                    <Switch color="primary" checked={UserRandom === "enabled"} onChange={async (e) => handleUserRandom(e.target.checked ? "enabled" : "disabled")} />
                  </Box>
                </Paper>
              </Grid>

               <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">{i18n.t("settings.settings.options.sendMsgTransfTicket")}</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Enviar aviso prévio de que o atendimento está sendo transferido de setor.</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" color={loadingSettingsTransfTicket ? 'primary' : 'textSecondary'}>{loadingSettingsTransfTicket ? i18n.t("settings.settings.options.updating") : (SettingsTransfTicket==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                    <Switch color="primary" checked={SettingsTransfTicket === "enabled"} onChange={async (e) => handleSettingsTransfTicket(e.target.checked ? "enabled" : "disabled")} />
                  </Box>
                </Paper>
              </Grid>

               <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">{i18n.t("settings.settings.options.closeTicketOnTransfer")}</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Encerra o ciclo atual do ticket automaticamente ao transferir para fila.</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" color={loadingCloseTicketOnTransfer ? 'primary' : 'textSecondary'}>{loadingCloseTicketOnTransfer ? i18n.t("settings.settings.options.updating") : (closeTicketOnTransfer===true || closeTicketOnTransfer==="true" ? "Habilitado" : "Desabilitado")}</Typography>
                    <Switch color="primary" checked={closeTicketOnTransfer === true || closeTicketOnTransfer === "true"} onChange={async (e) => handleCloseTicketOnTransfer(e.target.checked)} />
                  </Box>
                </Paper>
              </Grid>

               <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">{i18n.t("settings.settings.options.acceptCallWhatsapp")}</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Desative para disparar bloqueio e recado informando que chamadas não são aceitas.</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" color={loadingAcceptCallWhatsapp ? 'primary' : 'textSecondary'}>{loadingAcceptCallWhatsapp ? i18n.t("settings.settings.options.updating") : (AcceptCallWhatsapp==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                    <Switch color="primary" checked={AcceptCallWhatsapp === "enabled"} onChange={async (e) => handleAcceptCallWhatsapp(e.target.checked ? "enabled" : "disabled")} />
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">{i18n.t("settings.settings.options.acceptAudioMessageContact")}</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Permitir que os seus contatos enviem áudios por fluxo para o seu WhatsApp ou Canal.</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" color={loadingAcceptAudioMessageContact ? 'primary' : 'textSecondary'}>{loadingAcceptAudioMessageContact ? i18n.t("settings.settings.options.updating") : (acceptAudioMessageContact==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                    <Switch color="primary" checked={acceptAudioMessageContact === "enabled"} onChange={async (e) => handleAcceptAudioMessageContact(e.target.checked ? "enabled" : "disabled")} />
                  </Box>
                </Paper>
              </Grid>

               <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">Assinatura Inclusa</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Habilitar se o Atendente poderá retirar ou manter a identificação de "Nome: ..." nas respostas.</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" color={loadingSendSignMessage ? 'primary' : 'textSecondary'}>{loadingSendSignMessage ? i18n.t("settings.settings.options.updating") : (sendSignMessage==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                    <Switch color="primary" checked={sendSignMessage === "enabled"} onChange={async (e) => handleSendSignMessage(e.target.checked ? "enabled" : "disabled")} />
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">Saudação Fila Única</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Forçar envio da saudação padrão se empresa constar de uma única fila disponível para chatbot.</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" color={loadingSendGreetingMessageOneQueues ? 'primary' : 'textSecondary'}>{loadingSendGreetingMessageOneQueues ? i18n.t("settings.settings.options.updating") : (sendGreetingMessageOneQueues==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                    <Switch color="primary" checked={sendGreetingMessageOneQueues === "enabled"} onChange={async (e) => handleSendGreetingMessageOneQueues(e.target.checked ? "enabled" : "disabled")} />
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">Enviar Posição da Fila</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Informa o ciente em que posição de atendimento ele se encontra nas filas.</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" color={loadingSendQueuePosition ? 'primary' : 'textSecondary'}>{loadingSendQueuePosition ? i18n.t("settings.settings.options.updating") : (sendQueuePosition==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                    <Switch color="primary" checked={sendQueuePosition === "enabled"} onChange={async (e) => handleSendQueuePosition(e.target.checked ? "enabled" : "disabled")} />
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">Aviso Ticket Aguardando</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Envia a mensagem de aviso quando um ticket é devolvido para o estado pendente/aguardando.</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" color={loadingSendFarewellWaitingTicket ? 'primary' : 'textSecondary'}>{loadingSendFarewellWaitingTicket ? i18n.t("settings.settings.options.updating") : (sendFarewellWaitingTicket==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                    <Switch color="primary" checked={sendFarewellWaitingTicket === "enabled"} onChange={async (e) => handleSendFarewellWaitingTicket(e.target.checked ? "enabled" : "disabled")} />
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">Tags Obrigatórias</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Exigir aplicação de uma tag validada no ticket para efetuar o encerramento do chat.</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="caption" color={loadingRequiredTag ? 'primary' : 'textSecondary'}>{loadingRequiredTag ? i18n.t("settings.settings.options.updating") : (requiredTag==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                    <Switch color="primary" checked={requiredTag === "enabled"} onChange={async (e) => handleRequiredTag(e.target.checked ? "enabled" : "disabled")} />
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>{i18n.t("settings.settings.options.chatBotType")}</Typography>
                  </Box>
                  <FormControl fullWidth size="small">
                    <Select value={chatBotType} onChange={async (e) => handleChatBotType(e.target.value)}>
                      <MenuItem value={"text"}>Texto</MenuItem>
                      {/* Omitidos: lista ou botaos */}
                    </Select>
                  </FormControl>
                </Paper>
              </Grid>

            </Grid>
          </CardContent>
        </Card>

        {/* ======================= LGPD ======================= */}
        <Card elevation={0} sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              <Box>
                <Typography variant="h6" color="primary" fontWeight="bold">
                  LGPD e Privacidade
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Controles de aceitação de termos e tratativa de dados.
                </Typography>
              </Box>
              <Switch color="primary" checked={enableLGPD === "enabled"} onChange={async (e) => handleEnableLGPD(e.target.checked ? "enabled" : "disabled")} />
            </Box>

            {enableLGPD === "enabled" && (
              <Box mt={3}>
                <Divider sx={{ mb: 3 }} />
                <Grid spacing={3} container>
                  
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>{i18n.t("settings.settings.LGPD.welcome")}</Typography>
                    <TextField
                      fullWidth
                      id="lgpdMessage"
                      name="lgpdMessage"
                      multiline
                      rows={3}
                      variant="outlined"
                      value={lgpdMessage}
                      onChange={async (e) => handleLGPDMessage(e.target.value)}
                    />
                  </Grid>
                  
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>{i18n.t("settings.settings.LGPD.linkLGPD")}</Typography>
                    <TextField
                      fullWidth
                      id="lgpdLink"
                      name="lgpdLink"
                      variant="outlined"
                      value={lgpdLink}
                      onChange={async (e) => handleLGPDLink(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                      <Box>
                        <Typography variant="subtitle1" fontWeight="bold">Consentimento Constante</Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Sempre pedir consentimento para o contato (LGPD) a cada contato reiniciado.</Typography>
                      </Box>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="caption" color={loadingLGPDConsent ? 'primary' : 'textSecondary'}>{loadingLGPDConsent ? i18n.t("settings.settings.options.updating") : (lgpdConsent==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                        <Switch color="primary" checked={lgpdConsent === "enabled"} onChange={async (e) => handleLGPDConsent(e.target.checked ? "enabled" : "disabled")} />
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                      <Box>
                        <Typography variant="subtitle1" fontWeight="bold">Mensagem Deletada Pelo Contato</Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Ocultar o bloco e não mostrar o que o contato apagou (Apagar para todos).</Typography>
                      </Box>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="caption" color={loadingLGPDDeleteMessage ? 'primary' : 'textSecondary'}>{loadingLGPDDeleteMessage ? i18n.t("settings.settings.options.updating") : (lgpdDeleteMessage==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                        <Switch color="primary" checked={lgpdDeleteMessage === "enabled"} onChange={async (e) => handleLGPDDeleteMessage(e.target.checked ? "enabled" : "disabled")} />
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                      <Box>
                        <Typography variant="subtitle1" fontWeight="bold">Ofuscar Número Cliente</Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Oscentar e esconder os números para os atendentes normais com intuito de proteção de leads.</Typography>
                      </Box>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="caption" color={loadingLGPDHideNumber ? 'primary' : 'textSecondary'}>{loadingLGPDHideNumber ? i18n.t("settings.settings.options.updating") : (lgpdHideNumber==="enabled" ? "Habilitado" : "Desabilitado")}</Typography>
                        <Switch color="primary" checked={lgpdHideNumber === "enabled"} onChange={async (e) => handleLGPDHideNumber(e.target.checked ? "enabled" : "disabled")} />
                      </Box>
                    </Paper>
                  </Grid>

                </Grid>
              </Box>
            )}
          </CardContent>
        </Card>

        {/* ======================= TEXTOS PERSONALIZADOS ======================= */}
        <Card elevation={0} sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
          <CardContent>
            <Typography variant="h6" color="primary" gutterBottom fontWeight="bold">
              Mensagens Customizadas
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
              Customize as saudações, recusa ativa e status de fila que enviamos pelo WhatsApp.
            </Typography>
            
            <Grid spacing={3} container>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>{i18n.t("settings.settings.customMessages.transferMessage")}</Typography>
                <TextField
                  fullWidth
                  id="transferMessage"
                  name="transferMessage"
                  multiline
                  rows={3}
                  variant="outlined"
                  value={transferMessage}
                  required={SettingsTransfTicket === "enabled"}
                  onChange={async (e) => handletransferMessage(e.target.value)}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>{i18n.t("settings.settings.customMessages.greetingAcceptedMessage")}</Typography>
                <TextField
                  fullWidth
                  id="greetingAcceptedMessage"
                  name="greetingAcceptedMessage"
                  multiline
                  rows={3}
                  variant="outlined"
                  value={greetingAcceptedMessage}
                  required={SendGreetingAccepted === "enabled"}
                  onChange={async (e) => handleGreetingAcceptedMessage(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                 <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>{i18n.t("settings.settings.customMessages.AcceptCallWhatsappMessage")}</Typography>
                  <TextField
                    fullWidth
                    id="AcceptCallWhatsappMessage"
                    name="AcceptCallWhatsappMessage"
                    multiline
                    rows={3}
                    variant="outlined"
                    required={AcceptCallWhatsapp === "disabled"}
                    value={AcceptCallWhatsappMessage}
                    onChange={async (e) => handleAcceptCallWhatsappMessage(e.target.value)}
                  />
              </Grid>

               <Grid item xs={12} md={6}>
                 <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>{i18n.t("settings.settings.customMessages.sendQueuePositionMessage")}</Typography>
                  <TextField
                    fullWidth
                    id="sendQueuePositionMessage"
                    name="sendQueuePositionMessage"
                    multiline
                    required={sendQueuePosition === "enabled"}
                    rows={3}
                    variant="outlined"
                    value={sendQueuePositionMessage}
                    onChange={async (e) => handlesendQueuePositionMessage(e.target.value)}
                  />
              </Grid>
              
              {scheduleType === "company" && (
              <Grid item xs={12} md={6}>
                 <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>{i18n.t("whatsappModal.form.outOfHoursMessage")}</Typography>
                  <TextField
                    fullWidth
                    id="outOfHoursMessage"
                    name="outOfHoursMessage"
                    multiline
                    rows={3}
                    variant="outlined"
                    value={outOfHoursMessage}
                    onChange={async (e) => handleOutOfHoursMessage(e.target.value)}
                  />
              </Grid>
              )}

            </Grid>
          </CardContent>
        </Card>

      </Box>
    </>
  );
}